export default __webpack_public_path__ + "static/media/img-3.3125c63d.png";